export default __webpack_public_path__ + "img/settings-materials.a7fce33b.png";